import React, { useState, useRef, useEffect } from 'react';

const ScrollToBottom = (props) => {
  const num = props.children.length;
  const ref = useRef(null);
  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);

  useEffect(() => {
    if (ref === null) {
      return;
    }

    const scrollListener = (e) => {
      setShouldScrollToBottom(Math.abs(node.scrollTop + node.clientHeight - node.scrollHeight) < 5);
    };

    const node = ref.current;
    node.addEventListener('scroll', scrollListener);
    if (shouldScrollToBottom) {
      node.removeEventListener('scroll', scrollListener);
      node.scrollTop = node.scrollHeight - node.clientHeight;
      node.addEventListener('scroll', scrollListener);
    }

    return (() => {
      node.removeEventListener('scroll', scrollListener);
    });
  }, [num, shouldScrollToBottom]);

  return (
    <div ref={ref} className={props.className}>
      {props.children}
    </div>
  );
}

export default ScrollToBottom;